import { Sentry } from "@/lib/sentry";

export function logMutationError({
  mutation,
  args,
  error,
}: {
  mutation: string;
  args?: unknown;
  error: unknown;
}) {
  const payload = { mutation, args, error };
  console.error("[mutation error]", payload);
  if (import.meta.env.PROD) {
    Sentry.captureException(error, { extra: { mutation, args } });
  }
}

export function logInfo(message: string, context?: Record<string, unknown>) {
  console.info(`[info] ${message}`, context ?? "");
}
